<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <path class="cls-3" d="M79.32,79.73H10.68c-.76,0-1.37-.8-1.37-1.79V12.06c0-.99,.61-1.79,1.37-1.79s1.37,.8,1.37,1.79V76.15H79.32c.76,0,1.37,.8,1.37,1.79s-.61,1.79-1.37,1.79Z"/>
  <g>
    <path class="cls-3" d="M10.81,69.66c-.38,0-.77-.15-1.06-.44-.59-.59-.59-1.54,0-2.12l14.2-14.2c.5-.5,1.29-.58,1.88-.19l9.74,6.37,19.19-23.06c.26-.32,.65-.51,1.06-.54,.42-.03,.82,.12,1.12,.4l10.9,10.13,7.98-4.23c.73-.39,1.64-.11,2.03,.62,.39,.73,.11,1.64-.62,2.03l-8.92,4.73c-.56,.3-1.26,.21-1.72-.23l-10.52-9.78-19.03,22.86c-.49,.58-1.34,.71-1.97,.3l-9.84-6.43-13.34,13.34c-.29,.29-.68,.44-1.06,.44Z"/>
    <g>
      <circle class="cls-1" cx="35.48" cy="60.19" r="3.09"/>
      <path class="cls-2" d="M35.48,64.28c-2.25,0-4.09-1.83-4.09-4.08s1.83-4.08,4.09-4.08,4.08,1.83,4.08,4.08-1.83,4.08-4.08,4.08Zm0-6.17c-1.15,0-2.09,.94-2.09,2.08s.94,2.08,2.09,2.08,2.08-.94,2.08-2.08-.94-2.08-2.08-2.08Z"/>
    </g>
    <g>
      <circle class="cls-1" cx="56.1" cy="37.83" r="3.09"/>
      <path class="cls-2" d="M56.1,41.92c-2.25,0-4.08-1.83-4.08-4.09s1.83-4.08,4.08-4.08,4.09,1.83,4.09,4.08-1.83,4.09-4.09,4.09Zm0-6.17c-1.15,0-2.08,.94-2.08,2.08s.94,2.09,2.08,2.09,2.09-.94,2.09-2.09-.94-2.08-2.09-2.08Z"/>
    </g>
    <g>
      <circle class="cls-1" cx="68.13" cy="47.83" r="3.09"/>
      <path class="cls-2" d="M68.13,51.92c-2.25,0-4.09-1.83-4.09-4.08s1.83-4.09,4.09-4.09,4.08,1.83,4.08,4.09-1.83,4.08-4.08,4.08Zm0-6.17c-1.15,0-2.09,.94-2.09,2.09s.94,2.08,2.09,2.08,2.08-.94,2.08-2.08-.94-2.09-2.08-2.09Z"/>
    </g>
    <g>
      <circle class="cls-1" cx="25.01" cy="53.96" r="3.09"/>
      <path class="cls-2" d="M25.01,58.04c-2.25,0-4.08-1.83-4.08-4.08s1.83-4.08,4.08-4.08,4.08,1.83,4.08,4.08-1.83,4.08-4.08,4.08Zm0-6.17c-1.15,0-2.08,.94-2.08,2.08s.94,2.08,2.08,2.08,2.08-.94,2.08-2.08-.94-2.08-2.08-2.08Z"/>
    </g>
    <g>
      <circle class="cls-1" cx="77.39" cy="42.38" r="3.09"/>
      <path class="cls-2" d="M77.39,46.47c-2.25,0-4.09-1.83-4.09-4.08s1.83-4.08,4.09-4.08,4.08,1.83,4.08,4.08-1.83,4.08-4.08,4.08Zm0-6.17c-1.15,0-2.09,.94-2.09,2.08s.94,2.08,2.09,2.08,2.08-.94,2.08-2.08-.94-2.08-2.08-2.08Z"/>
    </g>
  </g>
</svg>
</template>
 
<script>
export default {
    name: "AllMetricsDashIcon",
}
</script>
<style scoped>
    .cls-1 {
      fill: #fff;
    }
    .cls-2 {
      fill: #0b5e73;
    }
    .cls-3 {
      fill: #59c5c7;
    }
</style>
